import { Container } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import WebComputerScreen from 'assets/img/web-development.png';

import PropTypes from 'prop-types';
import React from 'react';
import useWhyChooseUs from './assets/css/_whyChooseUs';
import { technologies } from './components/theme/dataset';
import Carousel from './components/Slider/Carousel';
import NeuralNetwork from './components/NeuralNetwork';
import AnimatedSection from 'components/AnimatedSection';

const WhyChooseUs = (props) => {
  const classes = useWhyChooseUs();

  return (
    <div id="why" className={classes.root}>
      <NeuralNetwork />
      <Container fixed style={{ position: 'relative', zIndex: 2 }}>
        <Grid container spacing={4} direction="row" justifyContent="space-around" alignItems="center" id="services">
          <Grid item xs={12}>
            <AnimatedSection animation="fadeInDown" delay={0}>
              <Typography variant="h4" align="center" className={classes.sectionTitle}>
                Why Partner With Cybros.Dev
              </Typography>
            </AnimatedSection>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <AnimatedSection animation="fadeInLeft" delay={200}>
              <Typography align="center" className={classes.sectionDescription} variant="h6">
                Our expertise in AI and modern software development methodologies ensures delivery of cutting-edge solutions.
                We combine technical excellence with agile practices to build scalable, maintainable systems that evolve with your business needs.
              </Typography>
            </AnimatedSection>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <AnimatedSection animation="fadeInRight" delay={300}>
              <img src={WebComputerScreen} alt="Software Development" style={{ maxWidth: '100%', filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.3))' }} />
            </AnimatedSection>
          </Grid>
        </Grid>

        <AnimatedSection animation="fadeInUp" delay={400}>
          <Carousel title="main-carousel" technologies={technologies} />
        </AnimatedSection>
      </Container>
    </div>
  );
};

WhyChooseUs.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
};

export default WhyChooseUs;
